const BRANDS = [
  { name: "Jaipur Watch Company", logo: "/brands/jaipur.png" },
  { name: "Pashma Global", logo: "/brands/pashma.png" },
  { name: "Exotic India Art", logo: "/brands/exotic.png" },
  { name: "HumbleTree", logo: "/brands/humbletree.png" },
  { name: "Materialé Homes", logo: "/brands/materiale.png" },
  { name: "Karm 108", logo: "/brands/karm.png" },
  { name: "BansuribyPoonam", logo: "/brands/bansuri.png" },
  { name: "The Urban Thing", logo: "/brands/urban.png" },
];

function Item({ b }) {
  return (
    <span className="inline-flex items-center gap-3 pr-[90px] shrink-0">
      {b.logo && (
        <img src={b.logo} alt={b.name} loading="lazy"
          className="h-7 md:h-8 w-auto max-w-[110px] object-contain" />
      )}
      <span className="font-mono uppercase text-[14px] tracking-[0.08em] text-black whitespace-nowrap">{b.name}</span>
    </span>
  );
}

function Row() {
  return (
    <span className="inline-flex items-center">
      {BRANDS.map((b) => <Item key={b.name} b={b} />)}
    </span>
  );
}

export default function BrandMarquee() {
  return (
    <div className="w-full overflow-hidden py-2" data-testid="brands-marquee">
      <div className="qissa-marquee" style={{ animationDuration: "55s" }}>
        <Row />
        <Row />
      </div>
    </div>
  );
}
